import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-array/src/zip.js
// module id = 242
// module chunks = 0